// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("adminLoggedIn");

  if (!isLoggedIn) {
    // Giriş yapılmamışsa admin-login'e yönlendir
    return <Navigate to="/admin-login" replace />;
  }

  return children; // Giriş yapıldıysa sayfayı göster
};

export default ProtectedRoute;
